import { StatusChipVariant } from '@occc-app/design-system';
import { Triggered_Message_Status } from '@occc/graphql';

export const PAGE_TITLE = 'Triggered Messages';
export const PAGE_SUBTITLE =
  'Trigger messages to your consumers when they take a qualifying action';
export const TRIGGERED_MESSAGES_LIST_QUERY_PAGE_SIZE = 15;
export const TRIGGERED_MESSAGES_LIST_TABLE_TITLE = 'Messages';

export const chipVariantByStatus: Record<Triggered_Message_Status, StatusChipVariant> = {
  [Triggered_Message_Status.Enabled]: 'success',
  [Triggered_Message_Status.Disabled]: 'error',
};
